// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__33l8B","calendarButtons":"ClockData_calendarButtons__s14al"};